<template>
    <modal id="candidate-email-modal"
           size="large"
           v-model="showModal"
           :title="$t('send_email')"
           @submit="submitData"
           :btnLabel="$t('send')"
           :loading="loading"
           :preloader="preloader">
        <form
            ref="form"
            :data-url='`${TENANT_BASE_URL}/app/candidate/${candidate.id}/email`'
            @submit.prevent="submitData"
        >
            <app-form-group
                :label="$t('subject')"
                type="text"
                :placeholder="$placeholder('subject', '')"
                v-model="formData.subject"
                :error-message="$errorMessage(errors, 'subject')"
                :required="true"
            />
            <div class="form-group">
                <label for="text-editor-for-remark">{{ $t('content') }}</label>
                <app-input
                    row="10"
                    type="text-editor"
                    v-model="formData.content"
                    id="text-editor-for-content"
                    :placeholder="$textAreaPlaceHolder('content')"
                    :error-message="$errorMessage(errors, 'content')"
                    :required="true"
                />
            </div>
        </form>
    </modal>
</template>

<script>
import FormHelperMixins from "../../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../../common/Mixin/Global/ModalMixin";
import {TENANT_BASE_URL} from "../../../../../common/Config/UrlHelper";
import {formDataAssigner} from "../../../../../common/Helper/Support/FormHelper";

export default {
    name  : "CandidateEmailModal",
    mixins: [FormHelperMixins, ModalMixin],
    props : {
        candidate: null
    },
    data() {
        return {
            TENANT_BASE_URL,
            formData: {},
        }
    },
    methods: {
        submitData() {
            let url      = this.$refs.form.dataset["url"];
            let formData = formDataAssigner(new FormData, this.formData);

            this.submitFromFixin('post', url, formData);
        },
        afterSuccess({data}) {
            this.loading  = false;
            this.formData = {};
            this.errors   = {};
            $('#candidate-email-modal').modal('hide');
            this.$emit('input', false);
            this.$toastr.s('', data.message);
        },
    },
}
</script>

